import React, { PropsWithChildren } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableCellProps,
  TableContainer,
} from '@mui/material';

import styles from '../Taskbar.module.css';

export function SegmentWrapper({ children }: PropsWithChildren) {
  return (
    <div className={styles.segment_info}>
      <TableContainer>
        <Table>
          <TableBody>{children}</TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
type StyledCellProps = PropsWithChildren<TableCellProps>;

export function StyledCell({ children, ...rest }: StyledCellProps) {
  return <TableCell className={styles.TableCell}>{children}</TableCell>;
}

export function NoSegmentSelected() {
  return <div className={styles.segment_info}>No segment selected</div>;
}
